// WP50 P5b notification bell: the bell (or Alt+B, or a "See all" link) opens the slide-over panel and loads the For me tab.
// In the panel Up/Down move between items, Left/Right between tabs; Esc closes it (native dialog) and focus returns to the page.

const panel = () => document.getElementById("notif-panel") as HTMLDialogElement | null;

function openPanel() {
  const dialog = panel();
  if (!dialog || dialog.open) return;
  dialog.showModal();
  document.body.dispatchEvent(new CustomEvent("notif-open"));
}

document.addEventListener("click", (ev) => {
  if (ev.target instanceof Element && ev.target.closest("[data-open-bell]")) openPanel();
});
document.body.addEventListener("kit:alt-b", openPanel);

document.addEventListener("keydown", (ev) => {
  const dialog = panel();
  const el = ev.target instanceof HTMLElement ? ev.target : null;
  if (!dialog?.open || !el || !dialog.contains(el)) return;
  if (ev.key === "ArrowDown" || ev.key === "ArrowUp") {
    const items = Array.from(dialog.querySelectorAll<HTMLElement>(".notif-item"));
    if (items.length === 0) return;
    ev.preventDefault();
    ev.stopPropagation();
    const at = items.indexOf(el);
    items[ev.key === "ArrowDown" ? Math.min(at + 1, items.length - 1) : Math.max(at - 1, 0)]?.focus();
  } else if (ev.key === "ArrowLeft" || ev.key === "ArrowRight") {
    // from anywhere in the panel: the selected tab is the starting point when focus is elsewhere (e.g. the close button)
    const tabs = Array.from(dialog.querySelectorAll<HTMLElement>("[role=tab]"));
    const at = el.matches("[role=tab]") ? tabs.indexOf(el) : tabs.findIndex((t) => t.getAttribute("aria-selected") === "true");
    if (at < 0) return;
    const next = tabs[(at + (ev.key === "ArrowRight" ? 1 : tabs.length - 1)) % tabs.length];
    ev.preventDefault();
    ev.stopPropagation();
    // htmx wires swapped-in tabs only at settle (~20 ms after the swap); process first so a quick key is not lost
    (window as any).htmx?.process(next);
    next?.click();
  }
}, true);   // capture: the page-wide arrow keys (keyboard.ts) must not see keys meant for the panel

// After a tab loads, keep the keyboard on the selected tab (the panel body was replaced).
document.addEventListener("htmx:afterSwap", (ev) => {
  const target = ev.target instanceof Element ? ev.target : null;
  if (target?.id === "notif-body" && panel()?.open) target.querySelector<HTMLElement>("[role=tab][aria-selected=true]")?.focus();
});
